import React from 'react';

const FeaturedItems = ({ item }) => {
  const formatDate = (date) => {
    const dateObj = new Date(date);
    // const month = dateObj.getUTCMonth() + 1;
    const month = dateObj.toLocaleString('es-MX', { month: 'long' });
    const day = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
    return `${day} de ${month} del ${year}`;
  };

  return (
    <div className='featured__item sladio__items' key={item.id}>
      <div className='featured__item__image'>
        <img loading='auto' src={item.image[0]} alt={item.title} />
      </div>
      <div className='featured__item__content'>
        <p className='featured__item__subtitle'>{item.subtitle}</p>
        <h3 className='featured__item__title'>{item.title}</h3>
        <hr />
        <p className='featured__item__days'>
          {item.days <= 9 ? `0${item.days}` : item.days} días /{' '}
          {item.nights <= 9 ? `0${item.nights}` : item.nights} noches
        </p>
        <p className='featured__item__valid'>
          Valido hasta {formatDate(item.validityDate[1])}
        </p>
        <a
          href={item.pdf ? item.pdf : item.url}
          target='_blank'
          rel='noopener noreferrer'
        >
          {item.button}
        </a>
      </div>
    </div>
  );
};

export default FeaturedItems;
